/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ContactsStats
 */
export interface ContactsStats {
    /**
     * 
     * @type {number}
     * @memberof ContactsStats
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactsStats
     */
    averageScore?: number;
}

/**
 * Check if a given object implements the ContactsStats interface.
 */
export function instanceOfContactsStats(value: object): boolean {
    return true;
}

export function ContactsStatsFromJSON(json: any): ContactsStats {
    return ContactsStatsFromJSONTyped(json, false);
}

export function ContactsStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactsStats {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'averageScore': json['averageScore'] == null ? undefined : json['averageScore'],
    };
}

export function ContactsStatsToJSON(value?: ContactsStats | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'averageScore': value['averageScore'],
    };
}

